import { v4 as uuidv4 } from "uuid";
import { getBackgroundImageOptions } from "@/react/components/shared/BuilderUI/utils/backgroundHelpers";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@/react/components/shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@/react/components/shared/BuilderUI/utils/buttonStyleHelpers";
import {
  getFontSizeOptions,
  getLineHeightOptions,
} from "@/react/components/shared/BuilderUI/utils/textStyleHelpers";
import { getFontWeightOptions } from "@/react/components/shared/BuilderUI/utils/textStyleHelpers";
import { getColorOptions } from "@/react/components/shared/BuilderUI/utils/textStyleHelpers";
import { defaultData as defaultP1Data } from "@/react/components/shared/Emails/VisualEmailBuilder/Blocks/Content/PBlock/P1BlockDefaultData";
import { defaultData as defaultP2Data } from "@/react/components/shared/Emails/VisualEmailBuilder/Blocks/Content/PBlock/P2BlockDefaultData";
import type {
  BaseBlock,
  BaseProp,
} from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  createH5Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { defaultData as defaultH5Data } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Headings/H5Block/H5BlockDefaultData";
import { defaultStyles } from "./defaultStyles";

const createSectionContentTemplate = (
  taglineText: string,
  headingText: string,
  descriptionText: string,
): BaseProp => ({
  prop: "children",
  type: "children",
  value: [
    createPBlock({
      text: taglineText,
      baseData: defaultP1Data,
      styles: {
        fontWeight: getFontWeightOptions("600"),
        fontSize: getFontSizeOptions("16px"),
        lineHeight: getLineHeightOptions("1.5"),
        color: getColorOptions("var(--theme-email-color-text-primary)"),
        margin: getMarginOptions({
          defaultValue: {
            marginTop: "0",
            marginBottom: "12",
            marginLeft: "0",
            marginRight: "0",
          },
        }),
      },
    }),
    createH5Block({
      text: headingText,
      baseData: defaultH5Data,
      styles: {
        margin: getMarginOptions({
          defaultValue: {
            marginTop: "0",
            marginBottom: "20",
            marginLeft: "0",
            marginRight: "0",
          },
        }),
      },
    }),
    createPBlock({
      text: descriptionText,
      baseData: defaultP2Data,
      paragraphStyle: "p2",
      styles: {
        color: getColorOptions("var(--theme-email-color-text-primary)"),
        margin: getMarginOptions({
          defaultValue: {
            marginTop: "0",
            marginBottom: "0",
            marginLeft: "0",
            marginRight: "0",
          },
        }),
      },
    }),
  ],
});

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "FeatureBlock3",
  props: {
    section1Content: createSectionContentTemplate(
      "Tagline",
      "Heading",
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat.",
    ),
    section2Content: createSectionContentTemplate(
      "Tagline",
      "Heading",
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat.",
    ),
    section3Content: createSectionContentTemplate(
      "Tagline",
      "Heading",
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat.",
    ),
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        backgroundColor: getBackgroundColorOptions({
          defaultValue: defaultStyles.backgroundColor,
        }),
        backgroundImage: getBackgroundImageOptions(),
        padding: getPaddingOptions({
          defaultValue: defaultStyles.padding,
        }),
        margin: getMarginOptions({
          defaultValue: defaultStyles.margin,
        }),
      },
    },
  },
};
